import { useGetETSTicketNotificationSelector } from 'gcs-common/clients/api/entities/tickets/tickets-api-selectors';
import NotificationBadge from 'gcs-common/components/Notifications/NotificationBadge/NotificationBadge';
import TicketStatus from 'gcs-common/components/Tickets/TicketStatus/TicketStatus';
import { friendlyDate } from 'gcs-common/helper/dateHelper';
import { getSelectedChannelId } from 'gcs-common/slices/channels/channelsSelectors';
import type { TicketStati } from 'gcs-common/slices/tickets/ticketsConstants';
import { ticketIdSelected } from 'gcs-common/slices/tickets/ticketsSlice';
import { useDispatch, useSelector } from 'react-redux';
import styles from './styles.module.scss';

interface TicketCardProps {
  id: string;
  title: string;
  status: TicketStati;
  createdAt: string | undefined | null;
}

const TicketCard = (props: TicketCardProps) => {
  const { id, status, title, createdAt } = props;
  const dispatch = useDispatch();
  const channelId: string = useSelector(getSelectedChannelId);
  const ticketNotification = useGetETSTicketNotificationSelector(id);

  const selectTicket = () => {
    dispatch(ticketIdSelected({ ticketId: id, channelId, firstTime: false }));
  };

  return (
    <div role="button" tabIndex={-1} title={title} onClick={selectTicket} className={styles.ticket}>
      <div className={styles.ticketDetailLeft}>
        <span>Ticket Titel</span>
        <span>Erstelldatum</span>
        <span>{ticketNotification ? <NotificationBadge /> : <div className={styles.status}> ETS </div>}</span>
      </div>
      <div className={styles.ticketDetailRight}>
        <span className={styles.title} title={title}>
          {title}
        </span>
        <span>{friendlyDate(createdAt)}</span>
        <TicketStatus status={status} />
      </div>
    </div>
  );
};

export default TicketCard;
